import {
  TypeCarouselItemWithoutUnresolvableLinksResponse,
  TypeCarouselUDSWithoutUnresolvableLinksResponse,
} from 'contentful-types'

import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'
import { BlockRenderer } from 'src/siteBuilder/renderer/contentful/BlockRenderer'

import Carousel, { CarouselProps } from './Carousel'
import { ContentfulAnalyticsEventType } from '@/siteBuilder/utils/types/analytics'

const navigationStyleMap: Record<
  TypeCarouselUDSWithoutUnresolvableLinksResponse['fields']['carouselNavigationStyle'],
  CarouselProps['carouselNavigationStyle']
> = {
  'Multiple Items': 'multiple_items',
  Basic: 'basic',
  Tabs: 'tabs',
  Thumbnail: 'thumbnail',
}

const progressBarStyleMap = {
  Dots: 'dots',
  // Since Bar does not exist on UDS the progress bar color defaults to green, subtle is used to use the correct color
  Bar: 'subtle',
}

const ContentfulCarousel = withContentful<TypeCarouselUDSWithoutUnresolvableLinksResponse['fields'], CarouselProps>(
  Carousel,
  {
    carouselNavigationStyle: (props) => navigationStyleMap[props.fields.carouselNavigationStyle],
    navigationIconPosition: (props) =>
      props.fields?.navigationIconPosition.toLowerCase() as Lowercase<
        TypeCarouselUDSWithoutUnresolvableLinksResponse['fields']['navigationIconPosition']
      >,
    navigationIconSize: (props) =>
      props.fields?.navigationIconSize.toLowerCase() as Lowercase<
        TypeCarouselUDSWithoutUnresolvableLinksResponse['fields']['navigationIconSize']
      >,
    sysID: (props) => props.sys.id,
    entryTitle: (props) => props.fields.entryTitle,
    carouselItems: (props) => {
      return props.fields.carouselItems
        .filter(
          (item): item is TypeCarouselItemWithoutUnresolvableLinksResponse =>
            item && item.sys.contentType?.sys.id === 'carouselItem'
        )
        .map((item) => ({
          tabTitle: item.fields.tab,
          thumbnail: item.fields.thumbnail?.fields?.file?.url,
          children: <BlockRenderer block={item.fields.carouselItemContent} />,
          fullBleedBackground: item.fields.fullBleedBackground,
          inverseNavigationText: item.fields.inverseNavigationText,
          analyticsEvent: item.fields.analyticsEvent as unknown as ContentfulAnalyticsEventType,
        }))
    },
    enablePeeking: (props) => props?.fields?.enablePeeking,
    progressBarStyle: (props) =>
      progressBarStyleMap[
        props?.fields?.progressBarStyle as Lowercase<
          TypeCarouselUDSWithoutUnresolvableLinksResponse['fields']['progressBarStyle']
        >
      ],
  }
)

export default ContentfulCarousel
